export default "/images/LOGO-MAGNO.png?a50ba3cc5c1d10c13685c9029406f486";